import { render, staticRenderFns } from "./b2c-exchange.vue?vue&type=template&id=3f707e8b&"
import script from "./b2c-exchange.vue?vue&type=script&lang=js&"
export * from "./b2c-exchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports